<app-loading [type]="'spinner'" [value]="value" [showLoading]="showLoading"></app-loading>
<h2 class="title">dados</h2>
<div [formGroup]="dataForm" class="occurence-information-grid">
  <div class="nome-carteira-lbl" >
    <mat-form-field *ngIf="isVisualization" appearance="standard" >
      <mat-label>*nome do fundo/carteira</mat-label>
      <input matInput class="nome-carteira-input" formControlName="fName">
    </mat-form-field>
    <mat-form-field id="info-caracters" *ngIf="!isVisualization" appearance="standard" hintLabel="Digite pelo menos 3 caracteres." class="example-full-width">
      <mat-label>*nome do fundo/carteira</mat-label>
      <input
        type="text"
        matInput
        id="mySelectNameField"
        [formControl]="mySelectNameField"
        [matAutocomplete]="auto"
        [attr.required]="!isVisualization"
        (focus)="cleanObjects()">
        
        <div class="error-message">
          <mat-error *ngIf="fieldIsValid('fName') && getField('fName').errors?.required">
            Campo obrigatório.
          </mat-error>
        </div>
      
      <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectPortfolio($event)"  [displayWith]="getOptionLabel">
        <mat-option *ngIf="isLoading" class="is-loading">Carregando...</mat-option>
        <mat-option *ngIf="!havePortfolios">Não foram encontradas carteiras.</mat-option>
        <mat-option *ngFor="let option of filteredOptions" [value]="option">
          {{ option.name }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
  </div>
  <div class="cnpj-cpf-lbl padding-separator">

    <mat-form-field *ngIf="isVisualization" appearance="standard" >
      <mat-label>*CNPJ/CPF</mat-label>
      <input matInput class="cpf-carteira-input" formControlName="fCpfCnpj">
    </mat-form-field>
    <mat-form-field id="info-caracters"  *ngIf="!isVisualization" appearance="standard" hintLabel="Digite pelo menos 3 caracteres." class="example-full-width">
      <mat-label>*CNPJ/CPF</mat-label>
      <input
        type="text"
        matInput
        id="mySelectCnpjCpfField"
        [formControl]="mySelectCnpjCpfField"
        [matAutocomplete]="auto"
        (keyup)="$event.target.value= onlyNumbers($event.target.value)"
        (focus)="cleanObjects()">

        <div class="error-message">
          <mat-error *ngIf="fieldIsValid('fCpfCnpj') && getField('fCpfCnpj').errors?.required">
            Campo obrigatório.
          </mat-error>
          <mat-error *ngIf="getField('fCpfCnpj').errors?.cpfCnpjValidator && mySelectCnpjCpfField.value.length > 0">
            CNPJ/CPF inválido.</mat-error>
        </div>
        
      <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectPortfolio($event)"  [displayWith]="getOptionLabel">
        <mat-option *ngIf="isLoading" class="is-loading">Carregando...</mat-option>
        <mat-option *ngIf="!havePortfolios">Não foram encontrados CNPJ/CPF.</mat-option>
        <mat-option *ngFor="let option of filteredOptions" [value]="option">
          {{ option.cnpj }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>

  </div>
  <div class="codigo-carteira-lbl padding-separator">
    <mat-form-field  *ngIf="isVisualization" appearance="standard">
      <mat-label>código fundo/carteira</mat-label>
      <input matInput class="codigo-carteira-input" formControlName="fCode">
    </mat-form-field>
    <mat-form-field id="info-caracters" *ngIf="!isVisualization" appearance="standard" hintLabel="Digite pelo menos 3 caracteres." class="example-full-width">
      <mat-label>código fundo/carteira</mat-label>
      <input
        type="text"
        matInput
        id="mySelectCodeField"
        [formControl]="mySelectCodeField"
        [matAutocomplete]="auto"
        maxlength="20"
        (focus)="cleanObjects()" 
      >
      <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectPortfolio($event)"  [displayWith]="getOptionLabel">
        <mat-option *ngIf="isLoading" class="is-loading">Carregando...</mat-option>
        <mat-option *ngIf="!havePortfolios">Não foram encontrados códigos.</mat-option>
        <mat-option *ngFor="let option of filteredOptions" [value]="option">
          {{option.code}}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
  </div>
</div>
<mat-form-field appearance="standard" class="mt-10" *ngIf="isVisualization">
    <mat-label>status da demanda</mat-label>
    <input *ngIf="isVisualization" matInput class="occurence-status-demanda" value="{{statusDemanda}}" disabled>
</mat-form-field>
